import { render, staticRenderFns } from "./JourneyOne.vue?vue&type=template&id=08bfa46d"
import script from "./JourneyOne.vue?vue&type=script&lang=js"
export * from "./JourneyOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports